const namespace = 'bravissimo/footer';

// Footer Settings Group

export const RECEIVE_SETTINGS_GROUP = `${namespace}/RECEIVE_SETTINGS_GROUP`;

export default RECEIVE_SETTINGS_GROUP;
